import {
  organization_pharmacy_drugs_in_list,
  phdrug_collection_drug_list,
  phdrug_collection_drug_read,
  phdrug_categories_ng_list,
  phdrug_offers_list,
  phdrug_featured_list,
  phdrug_new_list,
  phdrug_best_seller_list,
  phdrug_collection_drug_brands_list,
  phdrug_offers_pack_list,
  phdrug_grouped_categories_list,
  phdrug_collection_drug_brands_bestsellers_list,
  phdrug_collection_drug_brands_news_list,
  phdrug_collection_drug_brands_offers_list,
  phdrug_collection_drug_brands_pack_list,
  phdrug_top_generic_list,
  phdrug_importation_list,
  phdrug_collection_drug_bought_with_list,
} from "@/lib/api-client.js";
import { getAxiosConfig as axconf } from "@/lib/api-config.js";
import { getAxiosConfigNoAuth as axconfNoAuth } from "@/lib/api-config.js";
import { getPharmacyCategories } from "@/lib/drugs.js";

import Vue from "vue";

const CATEGORIES_STATUS_NOT_LOADED = 0;
const CATEGORIES_STATUS_LOADING = 1;
const CATEGORIES_STATUS_LOADED = 2;
const CATEGORIES_STATUS_ERROR = 3;

export default {
  namespaced: true,
  state: () => ({
    drugslist: {
      items: [],
      currentPage: 0,
      perPage: 20,
      totalRows: 0,
    },
    drugs: [],
    groupedCategories: [],
    categories_ng_loading_status: CATEGORIES_STATUS_NOT_LOADED,
    categoriesTree: [],
    categoriesPlain: {},
    products_country: undefined,
    currentDrug: undefined,
    sliders: {},
    viewer: {
      products: [],
      total: 0,
    },
  }),
  actions: {
    REQUEST_PHARMACY_DRUGS_IN: ({ commit }, payload) => {
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        organization_pharmacy_drugs_in_list({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          pUuid: payload.pUuid,
          offset: offset,
          limit: payload.per_page,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            commit("MUTATE_DRUGS_IN", {
              per_page: payload.per_page,
              current_page: payload.current_page,
              data: response.data,
            });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_PHDRUGS_GROUPED_CATEGORIES_LIST: ({ commit }, payload) => {
      let offset = 0;
      if (payload.per_page && payload.current_page) {
        offset = payload.per_page * (payload.current_page - 1);
      }
      return new Promise((resolve, reject) => {
        phdrug_grouped_categories_list({
          $config: axconfNoAuth(),
          role: "vooyguest",
          roleUuid: "1",
          orderingLangtag: payload.langtag,
          limit: payload.per_page,
          site: 3,
          offset: offset,
        }).then(
          response => {
            commit("MUTATE_GROUPED_CATEGORIES", {
              data: response.data,
            });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_PHDRUGS_CATEGORIES_NG: ({ commit, dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        let offset = 0;
        // En la db hay unas 247 categorías, se fuerza
        // a 300 para obtener todas en una sola consulta.
        // Esto funcionará sólo si el server no limita
        // este parámetro a un número inferior. En caso
        // de limitarse, se harán varias consultas.
        let limit = 300;
        if (payload && payload.offset) {
          offset = payload.offset;
        }
        if (payload && payload.limit) {
          limit = payload.limit;
        }
        commit("SET_NG_CATEGORIES_LOADING_STATUS", CATEGORIES_STATUS_LOADING);
        return phdrug_categories_ng_list({
          $config: axconfNoAuth(),
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: limit,
          site: 3, // site market
        }).then(
          response => {
            commit("MUTATE_NG_CATEGORIES_PLAIN", {
              data: response.data,
            });
            resolve(response);
          },
          err => {
            commit("SET_NG_CATEGORIES_LOADING_STATUS", CATEGORIES_STATUS_ERROR);
            reject(err);
          }
        );
      }).then(response => {
        if (response.data.next) {
          var nexturl = new URL(response.data.next);
          let indexOfLimit = nexturl.search.indexOf("limit");
          let indexOfOffset = nexturl.search.indexOf("offset");
          if (indexOfLimit >= 0 && indexOfOffset >= 0) {
            let limit = response.data.next.match(
              "[?&]" + "limit" + "=([^&]+)"
            ) || [undefined, undefined];
            let offset = response.data.next.match(
              "[?&]" + "offset" + "=([^&]+)"
            ) || [undefined, undefined];
            return dispatch("REQUEST_PHDRUGS_CATEGORIES_NG", {
              limit: limit[1],
              offset: offset[1],
            });
          }
        } else {
          // cuando se hayan obtenido todas las categorías
          // del server, se montan en árbol
          commit("MUTATE_NG_CATEGORIES_TREE");
          // tras montarse las categorías, marcamos como carga concluida
          commit("SET_NG_CATEGORIES_LOADING_STATUS", CATEGORIES_STATUS_LOADED);
        }
      });
    },
    REQUEST_PHDRUGS: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        phdrug_collection_drug_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          topHightSpeciality: payload.topHightSpeciality,
          hightSpeciality: payload.hightSpeciality,
          topDerma: payload.topDerma,
          category: payload.dcUuid,
          brands: payload.dbUuid,
          publicOrganization: payload.doUuid,
          groupedCategory: payload.groupedCategoryUuid,
          uuid: payload.dUuid,
          ordering: payload.ordering,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_IMPORTATION_PHDRUGS: ({ rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        phdrug_importation_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          topHightSpeciality: payload.topHightSpeciality,
          hightSpeciality: payload.hightSpeciality,
          category: payload.dcUuid,
          brands: payload.dbUuid,
          publicOrganization: payload.doUuid,
          groupedCategory: payload.groupedCategoryUuid,
          uuid: payload.dUuid,
          ordering: payload.ordering,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_PHDRUGS_TOP_GENERIC: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        phdrug_top_generic_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          topHightSpeciality: payload.topHightSpeciality,
          hightSpeciality: payload.hightSpeciality,
          category: payload.dcUuid,
          brands: payload.dbUuid,
          publicOrganization: payload.doUuid,
          groupedCategory: payload.groupedCategoryUuid,
          uuid: payload.dUuid,
          ordering: payload.ordering,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DRUGS_TOP: ({ dispatch }, payload) => {
      payload.top = true;
      payload.ordering = "top_farma_rank";
      return dispatch("REQUEST_PHDRUGS", payload);
    },
    REQUEST_DRUGS_TOP_SPECIALITY: ({ dispatch }, payload) => {
      payload.topHightSpeciality = true;
      payload.ordering = "top_ae_rank";
      return dispatch("REQUEST_PHDRUGS", payload);
    },
    REQUEST_DRUGS_TOP_DERMA: ({ dispatch }, payload) => {
      payload.topDerma = true;
      payload.ordering = "top_derma_rank";
      return dispatch("REQUEST_PHDRUGS", payload);
    },
    REQUEST_DRUGS_HIGHT_SPECIALITY: ({ dispatch }, payload) => {
      payload.hightSpeciality = true;
      return dispatch("REQUEST_PHDRUGS", payload);
    },
    REQUEST_DRUGS_OFFERS: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        phdrug_offers_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          category: payload.dcUuid,
          brands: payload.dbUuid,
          publicOrganization: payload.doUuid,
          uuid: payload.dUuid,
          ordering: payload.ordering,
          groupedCategory: payload.groupedCategoryUuid,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DRUGS_BEST_SELLER: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        phdrug_best_seller_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          category: payload.dcUuid,
          brands: payload.dbUuid,
          publicOrganization: payload.doUuid,
          uuid: payload.dUuid,
          ordering: payload.ordering,
          groupedCategory: payload.groupedCategoryUuid,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DRUGS_NEW_PRODUCTS: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        phdrug_new_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          category: payload.dcUuid,
          brands: payload.dbUuid,
          publicOrganization: payload.doUuid,
          uuid: payload.dUuid,
          ordering: payload.ordering,
          groupedCategory: payload.groupedCategoryUuid,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_GENERIC_PACKS_OFFERS: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        phdrug_offers_pack_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          category: payload.dcUuid,
          brands: payload.dbUuid,
          publicOrganization: payload.doUuid,
          uuid: payload.dUuid,
          ordering: payload.ordering,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            commit("MUTATE_DRUGS_IN", {
              per_page: payload.per_page,
              current_page: payload.current_page,
              data: response.data,
            });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DRUGS_FEATURED: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        phdrug_featured_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          category: payload.dcUuid,
          brands: payload.dbUuid,
          publicOrganization: payload.doUuid,
          uuid: payload.dUuid,
          ordering: payload.ordering,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    LOAD_PHDRUG: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      return new Promise((resolve, reject) => {
        phdrug_collection_drug_read({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          dUuid: payload.dUuid,
        }).then(
          response => {
            commit("SET_CURRENT_DRUG", response.data);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_PHDRUGS_BRANDS: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      return new Promise((resolve, reject) => {
        phdrug_collection_drug_brands_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          topGeneric: payload.topGeneric,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          topDerma: payload.topDerma,
          category: payload.dcUuid,
          publicOrganization: payload.doUuid,
          limit: 100000,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DRUGS_BRANDS_TOP_DERMA: ({ dispatch }, payload) => {
      payload.topDerma = true;
      return dispatch("REQUEST_PHDRUGS_BRANDS", payload);
    },
    REQUEST_DRUGS_BRANDS_TOP: ({ dispatch }, payload) => {
      payload.top = true;
      return dispatch("REQUEST_PHDRUGS_BRANDS", payload);
    },
    REQUEST_DRUGS_BRANDS_HIGHT_SPECIALITY: ({ dispatch }, payload) => {
      payload.hightSpeciality = true;
      return dispatch("REQUEST_PHDRUGS_BRANDS", payload);
    },
    REQUEST_DRUGS_BRANDS_TOP_SPECIALITY: ({ dispatch }, payload) => {
      payload.topHightSpeciality = true;
      return dispatch("REQUEST_PHDRUGS_BRANDS", payload);
    },
    REQUEST_DRUGS_BRANDS_TOP_GENERIC: ({ dispatch }, payload) => {
      payload.topGeneric = true;
      return dispatch("REQUEST_PHDRUGS_BRANDS", payload);
    },
    REQUEST_DRUGS_BRANDS_PACK_OFFERS: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      return new Promise((resolve, reject) => {
        phdrug_collection_drug_brands_pack_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          category: payload.dcUuid,
          publicOrganization: payload.doUuid,
          limit: 100000,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DRUGS_BRANDS_OFFERS: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      return new Promise((resolve, reject) => {
        phdrug_collection_drug_brands_offers_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          category: payload.dcUuid,
          publicOrganization: payload.doUuid,
          limit: 100000,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DRUGS_BRANDS_NEWS: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      return new Promise((resolve, reject) => {
        phdrug_collection_drug_brands_news_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          category: payload.dcUuid,
          publicOrganization: payload.doUuid,
          limit: 100000,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DRUGS_BRANDS_BEST_SELLERS: ({ commit, rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      return new Promise((resolve, reject) => {
        phdrug_collection_drug_brands_bestsellers_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          letter: payload.letter,
          search: payload.search,
          top: payload.top,
          hightSpeciality: payload.hightSpeciality,
          topHightSpeciality: payload.topHightSpeciality,
          category: payload.dcUuid,
          publicOrganization: payload.doUuid,
          limit: 100000,
        }).then(
          response => {
            commit("MUTATE_PRODUCTS_COUNTRY", response);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DRUGS_BOUGHT_WITH: ({ rootState }, payload) => {
      var config = axconfNoAuth();
      if (rootState.auth.authenticated) {
        config = axconf();
      }
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        phdrug_collection_drug_bought_with_list({
          $config: config,
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          dUuid: payload.dUuid,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
  },
  mutations: {
    MUTATE_NG_CATEGORIES_TREE: state => {
      for (const catuuid in state.categoriesPlain) {
        let category = state.categoriesPlain[catuuid];
        //
        if (category.parent) {
          // si la categoría tiene uuid del padre, se sustituye
          // por el ojeto del padre real. En caso de que este
          // valor no sea string, significa que ya se ha asignado
          // el padre en otra iteración
          if (typeof category.parent == "string") {
            category.parent = state.categoriesPlain[category.parent];
          }
          // si el padre se ha encontrado
          if (category.parent) {
            // al padre, se le añade esta categoría como subcategoría
            category.parent.subcategories.push(category);
          }
        } else {
          // si no tiene padre, es una categoria inicial, la metemos
          // en categoriesTree. Al ser un objeto, se mantiene
          // la referencia cuando se le añadan subcategorías
          state.categoriesTree.push(category);
        }
      }
    },
    // por cada resultado de la api, almacena con {catuuid: catobj, ...}
    MUTATE_NG_CATEGORIES_PLAIN: (state, payload) => {
      let categories = {};
      payload.data.results.forEach(category => {
        categories[category.uuid] = Object.assign({}, category, {
          subcategories: [],
        });
      });
      state.categoriesPlain = Object.assign(
        {},
        state.categoriesPlain,
        categories
      );
    },
    SET_NG_CATEGORIES_LOADING_STATUS: (state, status) => {
      Vue.set(state, "categories_ng_loading_status", status);
    },
    MUTATE_PRODUCTS_COUNTRY: (state, payload) => {
      if (!payload.results) {
        return;
      }
      if (!payload.results[0]) {
        return;
      }
      if (!payload.results[0].country) {
        return;
      }
      Vue.set(state, "products_country", payload.results[0].country);
    },
    MUTATE_DRUGS_IN: (state, payload) => {
      //console.log("total_rows2");
      //console.log(payload.data.count);
      var drugslist = state.drugslist;
      drugslist.items = payload.data.results;
      drugslist.perPage = payload.per_page;
      drugslist.currentPage = payload.current_page;
      drugslist.totalRows = payload.data.count;
      Vue.set(state, "drugslist", drugslist);
    },
    MUTATE_GROUPED_CATEGORIES: (state, payload) => {
      Vue.set(state, "groupedCategories", payload.data.results);
    },
    SET_CURRENT_DRUG: (state, drug) => {
      Vue.set(state, "currentDrug", drug);
    },
    MUTATE_SLIDER: (state, payload) => {
      Vue.set(state.sliders, payload.slider_id, {
        products: payload.data.products,
        total: payload.data.total,
      });
    },
    MUTATE_VIEWER: (state, payload) => {
      Vue.set(state, "viewer", {
        products: payload.products,
        total: payload.total,
      });
    },
  },
  getters: {
    categoriesMenuTree: state => {
      var categories =
        state.categoriesTree.filter(cat => {
          return cat.menu_header === true;
        }) || [];
      return categories;
    },
    groupedCategories: state => {
      return state.groupedCategories;
    },
    pharmacyCategories: state => {
      return getPharmacyCategories(state.categoriesTree);
    },
    categoriesTree: state => {
      return state.categoriesTree;
    },
    getAeUuid: state => {
      var ae_uuid = undefined;
      state.categoriesTree.forEach(rootcat => {
        rootcat.subcategories.forEach(subcategory => {
          if (ae_uuid) {
            return;
          }
          if (subcategory["department"] == "ae") {
            ae_uuid = subcategory["uuid"];
          }
        });
        if (ae_uuid) {
          return;
        }
      });
      return ae_uuid;
    },
    getCategoryByDepartment: state => department => {
      return state.categoriesTree.find(cat => cat.department == department);
    },
    getCategoryByUuid: state => categoryUuid => {
      return state.categoriesPlain[categoryUuid];
    },
    getCategoryPath: state => uuid => {
      let categoryPath = [];
      let currcategory = state.categoriesPlain[uuid];
      if (!currcategory) {
        return [];
      }
      let i = 0;
      for (i = 0; i < 10; i++) {
        categoryPath.unshift(currcategory);
        if (currcategory.parent) {
          currcategory = currcategory.parent;
        } else {
          break;
        }
      }
      return categoryPath;
    },
    getGroupedCategoryByUuid: state => groupedCategoryUuid => {
      // Buscamos el grupo de categorías en la lista de grupos
      return state.groupedCategories.find(
        gcat => gcat.uuid === groupedCategoryUuid
      );
    },
    getProductsCountry: state => {
      return state.products_country;
    },
    getSlider: state => slider_id => {
      return (
        state.sliders[slider_id] || {
          products: [],
          total: 0,
        }
      );
    },
  },
};
